var path = 'areas/projects/variables/variable_value_editor.html';
var html = "<div ng-style=style class=\"slick-edit-dialog slick-cell-editor variable-value-editor\"> <div class=value> <textarea hidefocus class=\"var-edit row\" ng-model=state.value ng-keydown=handleKeyDown($event)></textarea> </div> <div class=row> <div class=col-sm-6> <a ng-click=showEditor() href=\"\" role=button>Show editor</a> </div> <div class=\"col-sm-4 col-sm-offset-2 text-right\"> <button class=\"btn btn-success var-save\" ng-click=save()>Apply</button> <button class=\"btn btn-link var-cancel\" ng-click=cancel()>Cancel</button> </div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/variables/variable_value_editor.html
// module id = 7313395415553805
// module chunks = 1